import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import axios from "axios";
import MetaTags from 'react-meta-tags';

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { SimpleTextField, EmailField, TextAreaField, DropDownField } from '../commons/CustomFields';
import { useAlert, positions } from 'react-alert';
import GeneralStyles from '../../styles/GeneralStyles';
import FormStyles from '../../styles/FormStyles';

const useGeneralStyles = GeneralStyles;
const useStyles = FormStyles;

const initialValues = {
    category: '',
    fullName: '',
    email: '',
    subject: '',
    message: '',
};

const validationSchema = Yup.object({
    category: Yup.string().required('This field is required'),
    fullName: Yup.string().required('This field is required'),
    email: Yup.string().email('Invalid email').required('This field is required'),
    subject: Yup.string().required('This field is required'),
    message: Yup.string().required('This field is required'),
});

function Contact(props) {
    const classesG = useGeneralStyles();
    const classes = useStyles();
    const alert = useAlert();

    const [categoryField, setCategoryField] = useState('');
    const [categoryD, setCategoryD] = useState([
        { id: '', name: '' },
        { id: 1, name: 'General enquiries' },
        { id: 2, name: 'PR and media' },
        { id: 3, name: 'Working at Footballco' }
    ]);



    const onSubmit = async (values) => {

        const { fullName, email, subject, message } = values;

        try {
            axios.post(`https://e0pmnf39y0.execute-api.us-east-1.amazonaws.com/test/contact-us`,
                {
                    emailSend: categoryField,
                    fullName: fullName,
                    email: email,
                    subject: subject,
                    message: message,
                },
                // {
                //   headers: { Authorization: token },
                // }
            )
            alert.success(
                "We got your message. Thanks for getting in touch",
                { position: positions.BOTTOM_CENTER, type: 'success', timeout: 200000 }
            );
        } catch (error) {
            console.log('Error: ' + error);
            alert.error(
                "An error occurred while sending the email, please try again later.",
                { position: positions.BOTTOM_CENTER, type: 'error', timeout: 20 }
            );
        }
    };


    const wraper = (params) => {
        formik.handleChange(params);
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    const handleCategory = (params) => {
        setCategoryField(params.target.value);
        formik.handleChange(params);
    };

    return (
        <React.Fragment>
            <MetaTags>
                <title>Contact Fooballco | Footballco | </title>
                <meta name="description" content="Get in contact with Footballco" />
            </MetaTags>
            <div className={classesG.container}>

                <section className={classesG.section}>
                    <div className={classesG.contactSecondSectionContent}>
                        <div className={classesG.sectionBox}>
                            <div className={classesG.contactFirstSectionText}>
                                <h2>
                                    Get in touch with Footballco
                                </h2>
                                <form onSubmit={formik.handleSubmit}>
                                    <div>
                                        <h3 className={classes.pText}>
                                            Why are you contacting us today?
                                        </h3>
                                        <DropDownField
                                            className={classes.DropdownList}
                                            name="category"
                                            label="Select a category"
                                            value={categoryField}
                                            error={formik.errors.category}
                                            handleChange={handleCategory}
                                            data={categoryD}
                                        />
                                    </div>

                                    <div>
                                        <p className={classes.pLabel}>First and last name*</p>
                                        <SimpleTextField
                                            className={classes.texBoxes}
                                            classNameText={classes.textBoxesFill}
                                            name="fullName"
                                            error={formik.errors.fullName}
                                            handleChange={wraper}
                                        />
                                    </div>
                                    <div className={classes.formBoxs_2}>
                                        <p className={classes.pLabel}>Email Address*</p>
                                        <EmailField
                                            className={classes.texBoxes}
                                            classNameText={classes.textBoxesFill}
                                            name="email"
                                            error={formik.errors.email}
                                            handleChange={wraper}
                                        />
                                    </div>
                                    <div>
                                        <p className={classes.pLabel}>Subject</p>
                                        <SimpleTextField
                                            className={classes.texBoxes}
                                            classNameText={classes.textBoxesFill}
                                            name="subject"
                                            error={formik.errors.subject}
                                            handleChange={wraper}
                                        />
                                    </div>
                                    <div>
                                        <p className={classes.pLabel}>Comments</p>
                                        <TextAreaField
                                            className={classes.textAreaBoxes}
                                            classNameText={classes.textAreaBoxesFill}
                                            name="message"
                                            error={formik.errors.message}
                                            handleChange={wraper}
                                        />
                                    </div>
                                    <br></br>
                                    <div className={classes.contentButton}>
                                        <Button
                                            type="submit"
                                            autoFocus
                                            color="primary"
                                            className={classes.buttonBlack}
                                        >
                                            SEND
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>


                <Box mt={7}></Box>
            </div>
        </React.Fragment>
    );
}

export default (Contact);